import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { DocumentPayloadModel } from "../models/document-payload.model";
import { DocumentModel } from "../models/document.model";
import { safeFirstValueFrom } from "../../../shared/utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  uploadLocalCall(payload: DocumentPayloadModel) {
    return this.http.post<DocumentModel>(
      `${environment.api()}/document/upload/local`,
      payload,
    );
  }

  async loadById(id: string) {
    const doc = await safeFirstValueFrom(
      this.http.get<DocumentModel>(`${environment.api()}/document/byId/${id}`),
    );
    return doc;
  }
}
